import React, { createContext } from 'react'
import { Layer } from '@dustin-web/styledust/constants'

type LayerContextProps = {
  layer?: Layer
}

export const LayerContext = createContext<LayerContextProps>({})

type Props = {
  layer: Layer
  children: React.ReactNode
}

/**
 * A component wrapped in this provider may use the provider layer as an
 * override over that components default layer. The layer value can be
 * accessed with the utility useLayer hook.
 */
export const LayerProvider = ({ layer, children }: Props) => (
  <LayerContext.Provider value={{ layer }}>{children}</LayerContext.Provider>
)
